import React from "react";
import { Col, Row } from "reactstrap";

export default function StatsFold() {

    const icmStatConstants = {
        stats: {
            imgTitle: "Defaults till Date",
            statContent: [
                {
                    img: process.env.REACT_APP_IMAGES_PATH + "assetManagement.webp",
                    text: "₹ 1,250+ Crs",
                    subtext: "Asset Under Management",
                    alt: "stat-img"
                },
                {
                    img: process.env.REACT_APP_IMAGES_PATH + "avgReturns.webp",
                    text: "10%-12% XIRR",
                    subtext: "Avg. Returns Earned",
                    alt: "stat-img"
                },
                {
                    img: process.env.REACT_APP_IMAGES_PATH + "ontimePayment.webp",
                    text: "100%",
                    subtext: "On Time Payments",
                    alt: "stat-img"
                },
                {
                    img: process.env.REACT_APP_IMAGES_PATH + "investorCommunity.webp",
                    text: "1.5 Lakh +",
                    subtext: "Users",
                    alt: "stat-img"
                },
            ]
        },
    }

    return (
        <div className="stats-fold">
            <p className="title">Grow and Diversify your portfolio with confidence</p>
            <Row className="stats-container mb-4 text-center">
                <Col lg={4} sm={12} xs={12} md={6} className="img-container">
                    <img src= {process.env.REACT_APP_IMAGES_PATH + "zero.webp"} alt="asset-zero"/>
                    <p className="def-title">{icmStatConstants.stats.imgTitle}</p>
                </Col>
                <Col lg={8} sm={12} xs={12} md={6} className="col-stats">
                    {icmStatConstants.stats.statContent.map(item => (
                        <div className="cards">
                            <div className="img-shadow"><img src={item.img} alt={item.alt}/></div>
                            <div className="content">
                                <p className="title">{item.text}</p>
                                <p className="subtext">{item.subtext}</p>
                            </div>
                        </div>
                    ))}
                    <div className="hr"></div>
                </Col>
            </Row>
        </div>
    )
}
